import type {
  DataGridColumnOrderState,
  DataGridColumnPinningState,
  DataGridColumnsStateProps,
  DataGridColumnVisibilityState,
} from '@ibsys/kit';

/** Вид колонок грида: порядок, видимость и закрепление */
export type DataGridColumnsView = {
  /** Порядок колонок (массив id) */
  order: DataGridColumnOrderState;
  /** Видимость колонок (`false` — скрыта) */
  visibility: DataGridColumnVisibilityState;
  /** Закрепление колонок слева/справа */
  pinning: DataGridColumnPinningState;
};

/** Колбэки грида, которыми выставляется вид колонок, — подмножество `gridProps` хука `useDataGridColumnsState` */
export type DataGridColumnsViewHandlers = Pick<
  DataGridColumnsStateProps,
  'onColumnOrderChange' | 'onColumnVisibilityChange' | 'onColumnPinningChange'
>;

/**
 * Выставляет гриду заданный вид колонок — порядок, видимость и закрепление — тремя его колбэками.
 *
 * Нужен кнопке «Очистить»: она возвращает таблицу к исходному виду в обход `panelProps.onReset`
 * кита. Штатный сброс хука кита возвращает к значениям на момент монтирования, то есть к уже
 * сохранённым настройкам, — а «Очистить» должна показать вид таблицы, которую никто не настраивал.
 */
export const applyDataGridColumnsView = (handlers: DataGridColumnsViewHandlers, view: DataGridColumnsView): void => {
  handlers.onColumnOrderChange(view.order);
  handlers.onColumnVisibilityChange(view.visibility);
  handlers.onColumnPinningChange(view.pinning);
};
